/// <amd-module name="Dashboards/Directory/components/DashboardsDirectory" />
import * as React from "react";
import { getTfsPageDataModule } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataModule";
import { IDirectoryViewState } from "VSS/Features/ReduxDirectory/Contracts";
import { getDirectoryProviderProps, IDirectorySagaContext } from "VSS/Features/ReduxDirectory/Redux/getDirectoryProviderProps";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IRootProviderProps, RootProvider } from "VSS/Redux/Deprecated/RootProvider";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";
import { FeatureName } from "../DashboardsDirectoryConstants";
import { IDashboardsDirectoryArtifact } from "../DashboardsDirectoryContracts";
import { getDashboardDirectoryModule } from "../redux/DashboardsDirectoryModule";
import { ConnectedDashboardsDirectoryContentView } from "./DashboardDirectoryContentView";

/** The dashboard directory */
export class DashboardsDirectory extends VssComponent {
    private hubViewState: VssHubViewState;
    private rootProviderProps: IRootProviderProps<IDirectorySagaContext, IDirectoryViewState<IDashboardsDirectoryArtifact>>;

    constructor(props: never, context: IVssComponentContext) {
        super(props, context);

        this.hubViewState = new VssHubViewState(context.pageContext);
        this.rootProviderProps = getDirectoryProviderProps(
            {
                favoriteType: "Microsoft.TeamFoundation.Dashboards.Dashboard",
                hubName: FeatureName
            },
            this.hubViewState,
            context.pageContext,
            FeatureName,
            [getTfsPageDataModule(), getDashboardDirectoryModule()]
        );
    }

    public render(): JSX.Element | undefined {
        return (
            <RootProvider {...this.rootProviderProps}>
                <ConnectedDashboardsDirectoryContentView hubViewState={this.hubViewState} pageContext={this.context.pageContext} />
            </RootProvider>
        );
    }
}

VssComponent.register("dashboards-directory-view", DashboardsDirectory);
